module.exports = __webpack_public_path__ + "images/emoji/white_small_square.79d8586aec16ba527b39.png";